export const COMMON_LANGUAGE_OPTIONS = [
  'English',
  'Hindi',
  'Spanish',
  'French',
  'German',
  'Arabic',
  'Mandarin',
  'Japanese',
  'Portuguese',
  'Bengali',
];

export const MEETING_LANGUAGE_OPTIONS = COMMON_LANGUAGE_OPTIONS;

export const PREFERRED_LANGUAGE_OPTIONS = COMMON_LANGUAGE_OPTIONS;

const LANGUAGE_ALIAS_MAP = {
  inglish: 'English',
  eng: 'English',
  engligh: 'English',
  hindhi: 'Hindi',
  hind: 'Hindi',
  espanol: 'Spanish',
  mandrin: 'Mandarin',
  portugese: 'Portuguese',
  bangla: 'Bengali',
};

export const normalizeLanguageLabel = (value) => {
  const raw = String(value || '').trim();
  if (!raw) {
    return '';
  }

  const lower = raw.toLowerCase();
  const aliasMatch = LANGUAGE_ALIAS_MAP[lower];
  if (aliasMatch) {
    return aliasMatch;
  }

  const canonical = COMMON_LANGUAGE_OPTIONS.find((option) => option.toLowerCase() === lower);
  return canonical || raw;
};

export const parseLanguageCsv = (csvValue) => {
  const unique = new Set(
    String(csvValue || '')
      .split(',')
      .map((item) => normalizeLanguageLabel(item))
      .filter(Boolean)
  );

  return Array.from(unique);
};